import { YoutubeIcon } from 'components/atoms';
import {
  PiAddressBook,
  PiBell,
  PiCalendarDots,
  PiCassetteTape,
  PiChartBar,
  PiChatsCircle,
  PiCoins,
  PiDeviceMobile,
  PiHandWithdraw,
  PiHeadphones,
  PiHouseLine,
  PiIdentificationCard,
  PiMicrophoneStage,
  PiNotepad,
  PiPresentationChart,
  PiReceipt,
  PiScroll,
  PiShoppingBag,
  PiStorefront,
  PiUserFocus,
  PiUsers,
  PiVideo,
  PiVinylRecord,
  PiWallet,
} from 'react-icons/pi';
import { environment } from 'services/environment/Environment';
import { INavbarItem } from 'types/navbar/navbar.interface';

export const navbarItems = (
  clientModule = false,
  extendedTemplates = false,
): INavbarItem[] => [
  {
    path: '',
    name: 'home',
    icon: PiHouseLine,
    // permissionNames: ['StatisticsPermissionsLIST**']
  },
  {
    path: 'label',
    icon: PiIdentificationCard,
    permissionNames: ['LabelPermissionsLIST**'],
  },

  {
    path: 'artist',
    icon: PiMicrophoneStage,
    permissionNames: ['ArtistPermissionsLIST**'],
  },
  {
    path: 'track',
    icon: PiVinylRecord,
    permissionNames: ['TrackPermissionsLIST**'],
  },

  {
    path: 'video',
    icon: PiVideo,
    permissionNames: ['VideoPermissionsLIST**'],
  },
  {
    path: 'music-product-digital',
    icon: PiStorefront,
    name: 'products',
    permissionNames: [
      'DigitalMusicProductPermissionsLIST**',
      'PhysicalMusicProductPermissionsLIST**',
      'ChannelPermissionsLIST**',
      'MerchPermissionsLIST**',
    ],
    children: [
      {
        path: 'music-product-digital',
        icon: PiHeadphones,
        permissionNames: ['DigitalMusicProductPermissionsLIST**'],
      },
      {
        path: 'music-product-physical',
        icon: PiCassetteTape,
        permissionNames: ['PhysicalMusicProductPermissionsLIST**'],
      },
      {
        path: 'channel',
        icon: YoutubeIcon,
        permissionNames: ['ChannelPermissionsLIST**'],
      },
      {
        path: 'merch',
        icon: PiShoppingBag,
        permissionNames: ['MerchPermissionsLIST**'],
      },
    ],
  },
  ...(environment().node.nodeEnv === 'development'
    ? [
        {
          path: 'event',
          icon: PiCalendarDots,
          permissionNames: ['EventPermissionsLIST**'],
        },
      ]
    : []),
  {
    path: 'contracts',
    icon: PiScroll,
    name: 'contracts',
    permissionNames: [
      'ContractTemplatePermissionsLIST**',
      'ContractPermissionsLIST**',
    ],
    children: [
      {
        path: 'contracts',
        icon: PiScroll,
        permissionNames: ['ContractPermissionsLIST**'],
      },
      {
        path: 'contracts-to-expire',
        icon: PiScroll,
        permissionNames: ['ContractPermissionsLIST**'],
      },
      {
        path: 'templates',
        icon: PiScroll,
        permissionNames: ['ContractTemplatePermissionsLIST**'],
      },
      ...(extendedTemplates
        ? [
            {
              path: 'templates-extended',
              icon: PiScroll,
              permissionNames: ['ContractTemplatePermissionsLIST**'],
            },
          ]
        : []),
    ],
  },
  {
    path: 'statements',
    icon: PiChartBar,
    name: 'settlements',
    permissionNames: [
      'StatementPermissionsLIST**',
      'LabelReportPermissionsLIST**',
      'SettlementPermissionsLIST**',
      'AdvancePermissionsLIST**',
      'SettlementCostPermissionsLIST**',
    ],
    children: [
      {
        path: 'statements',
        icon: PiNotepad,
        permissionNames: ['StatementPermissionsLIST**'],
      },
      {
        path: 'raport',
        icon: PiCoins,
        permissionNames: ['LabelReportPermissionsLIST**'],
      },
      {
        path: 'settlement',
        icon: PiCoins,
        permissionNames: ['SettlementPermissionsLIST**'],
      },
      {
        path: 'unpaid-advance',
        name: 'advance',
        icon: PiWallet,
        permissionNames: ['AdvancePermissionsLIST**'],
      },
      {
        path: 'unpaid-cost',
        name: 'cost',
        icon: PiReceipt,
        permissionNames: ['SettlementCostPermissionsLIST**'],
      },
      {
        path: 'statistics',
        name: 'statistics',
        icon: PiChartBar,
        permissionNames: ['StatisticsPermissionsLIST**'],
      },
    ],
  },
  {
    path: 'settlement-order',
    icon: PiHandWithdraw,
    name: 'orders',
    permissionNames: [
      'LabelReportOrderPermissionsLIST**',
      'SettlementOrderPermissionsLIST**',
    ],
    children: [
      {
        path: 'label-reports',
        icon: PiPresentationChart,
        permissionNames: ['LabelReportOrderPermissionsLIST**'],
      },
      {
        path: 'settlement-order',
        icon: PiCalendarDots,
        permissionNames: ['SettlementOrderPermissionsLIST**'],
      },
    ],
  },
  ...(clientModule
    ? [
        {
          path: 'client-threads',
          icon: PiDeviceMobile,
          name: 'client',
          children: [
            {
              path: 'client-threads',
              icon: PiChatsCircle,
            },
            {
              path: 'client-users',
              icon: PiUsers,
            },
            {
              path: 'client-account',
              icon: PiUserFocus,
            },
          ],
        },
      ]
    : []),
  {
    path: 'notifications',
    icon: PiBell,
    permissionNames: ['NotificationPermissionsLIST**'],
  },
  {
    path: 'contacts-list',
    icon: PiAddressBook,
  },
];
